
export class OrderItemCancel {
    constructor({previewTriggerId, modalId, modalTriggerId, modalSubmitId, orderAlertId}) {
        this.previewTrigger = document.getElementById(previewTriggerId);
        this.modal = document.getElementById(modalId);
        this.init(modalTriggerId, modalSubmitId, orderAlertId);
    }

    async init(modalTriggerId, modalSubmitId, orderAlertId) {
        await this.initBoostrapModal();

        this.modalTrigger = document.getElementById(modalTriggerId);
        this.modalSubmit = document.getElementById(modalSubmitId);
        this.orderAlert = document.getElementById(orderAlertId);

        this.body = document.querySelector('body');
        this.html = document.querySelector('html');

        this.listen();
    }

    async initBoostrapModal() {
        if (this.modal) {
            let {default: Modal} = await import('bootstrap/js/dist/modal');
            this.bootstrapModal = new Modal(this.modal, {});
        }
    }

    listen() {
        const thisClass = this;

        if (this.previewTrigger) {
            this.previewTrigger.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const href = thisClass.previewTrigger.getAttribute('href');

                thisClass.getData(href)
                    .then((data) => {
                        thisClass.redrawItems(data);
                    });
            });
        }

        if (this.modalTrigger) {
            this.modalTrigger.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                thisClass.bootstrapModal.show();
            });
        }

        if (this.modalSubmit) {
            this.modalSubmit.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const href = thisClass.modalSubmit.getAttribute('href');

                thisClass.getData(href)
                    .then((data) => {
                        thisClass.redraw(data);
                    });
            });
        }
    }

    getData(url) {
        return fetch(url)
            .then(data => {
                return data.json();
            }).then().catch(error => {
            });
    }

    redrawItems(items) {
        const message = this.previewTrigger.getAttribute('data-message');

        Array.from(items).forEach(function(item) {
            const orderItem = document.getElementById(item.uuid);

            if (orderItem) {
                const orderItemState = orderItem.querySelector('.order-item-state');

                if (orderItemState) {
                    orderItemState.innerHTML = message + ' ' + item.amount;
                    orderItemState.classList.add('text-danger');
                }
            }
        });

        this.modalTrigger.classList.remove('d-none');
        this.previewTrigger.classList.add('d-none');
    }

    redraw(data) {
        this.orderAlert.classList.remove('d-none');

        if (data.message) {
            this.orderAlert.classList.add('alert-success');
            this.orderAlert.innerHTML = data.message;
        } else {
            this.orderAlert.classList.add('alert-danger');
            this.orderAlert.innerHTML = data.error;
        }

        this.bootstrapModal.hide();
        this.modalTrigger.classList.add('d-none');
    }

}
